import * as React from 'react';

import {HelpModal} from 'shells/modal/help-modal';
import {SpacerGroup} from 'shells/spacer/spacer-group';
import {ModalBody} from 'shells/typography/modal-body';
import {ModalHeader} from 'shells/typography/modal-header';

import {AddressModalGraphic} from './assets/address-modal-graphic';

type Props = {
    isOpen: boolean;
    onClose: () => void;
};

export function AddressModal(props: Props) {
    return (
        <HelpModal
            isOpen={props.isOpen}
            onClose={props.onClose}
            artImage={<AddressModalGraphic />}
            bodyComponent={
                <div className='pad-16'>
                    <ModalHeader>Add a merge tag with your mailing address</ModalHeader>
                    <SpacerGroup mb={32}>
                        <ModalBody>
                            A <b>merge tag</b> with your company&apos;s mailing address is required
                            in every message.
                        </ModalBody>
                    </SpacerGroup>
                    <ModalBody as='p'>1. Place your cursor in any text box</ModalBody>
                    <ModalBody as='p'>
                        2. Click the “More” dropdown in the text toolbar and select “Merge tags”
                    </ModalBody>
                    <ModalBody as='p'>
                        3. Choose “Mailing address” from the dropdown and add it to your message
                    </ModalBody>
                </div>
            }
        />
    );
}
